import type { ReactNode } from 'react';
import { LandingLayout } from '@/features/landing/components/LandingLayout';

interface LegalPageLayoutProps {
  title: string;
  children: ReactNode;
}

export function LegalPageLayout({ title, children }: LegalPageLayoutProps) {
  return (
    <LandingLayout>
      <article className="relative">
        <div className="mx-auto max-w-[820px] px-6 py-20 lg:px-10 lg:py-28">
          <h1 className="display-tight mb-12 text-[40px] leading-[1.05] text-[#E2EDE7] sm:text-[52px]">
            {title}
          </h1>
          <div className="prose prose-invert max-w-none">{children}</div>
        </div>
      </article>
    </LandingLayout>
  );
}

export default LegalPageLayout;
